module.exports = __webpack_public_path__ + "static/media/trash-2 9.9170f469.png";